import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormControl, Button } from 'modules/common/components';
import { StageItemContainer } from 'modules/common/styles/stage';
import { PROBABILITY } from '../constants';
import Toggle from 'react-toggle';
import { InlineItems } from 'modules/common/styles/stage';
const propTypes = {
  stage: PropTypes.object,
  remove: PropTypes.func,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  placeholder: PropTypes.string,
  keyname: PropTypes.string,
  valuename: PropTypes.string,
  showglobalTrue: PropTypes.bool,
  showSpeechRate: PropTypes.bool,
  showcombineDigits: PropTypes.bool
};
class StageItem extends Component {
  render() {
    const { stage, onChange, onKeyPress, remove, placeholder } = this.props;
    const probabilties = PROBABILITY.ALL;

    return (
      <div>
        <StageItemContainer key={stage._id}>
          <FormControl
            defaultValue={stage[this.props.keyname]}
            type="text"
            placeholder={placeholder}
            onKeyPress={onKeyPress}
            autoFocus
            name={this.props.keyname}
            onChange={onChange.bind(this, stage._id, '')}
          />
          <FormControl
            defaultValue={stage[this.props.valuename]}
            type="text"
            placeholder={placeholder}
            onKeyPress={onKeyPress}
            autoFocus
            name={this.props.valuename}
            onChange={onChange.bind(this, stage._id, '')}
          />

          <Button
            btnStyle="danger"
            size="small"
            onClick={remove.bind(this, stage._id)}
            icon="cancel-1"
          />
        </StageItemContainer>
        <StageItemContainer>
          {this.props.showglobalTrue && (
            <InlineItems>
              Global
              <Toggle
                checked={stage['global']}
                onChange={onChange.bind(this, stage._id, 'global')}
                icons={{
                  checked: null,
                  unchecked: null
                }}
              />
            </InlineItems>
          )}
        </StageItemContainer>
        <StageItemContainer>
          {this.props.showSpeechRate && (
            <InlineItems>
              Speech Rate
              <FormControl
                defaultValue={stage['speechRate']}
                type="number"
                placeholder={placeholder}
                onKeyPress={onKeyPress}
                autoFocus
                name={this.props.valuename}
                onChange={onChange.bind(this, stage._id, 'speechRate')}
              />
            </InlineItems>
          )}
        </StageItemContainer>

        <StageItemContainer>
          {this.props.showcombineDigits && (
            <InlineItems>
              Combine Digits
              <Toggle
                checked={stage['combineDigits']}
                onChange={onChange.bind(this, stage._id, 'combineDigits')}
                icons={{
                  checked: null,
                  unchecked: null
                }}
              />
            </InlineItems>
          )}
        </StageItemContainer>
      </div>
    );
  }
}

StageItem.propTypes = propTypes;

export default StageItem;



// WEBPACK FOOTER //
// ./src/modules/common/components/StageItem.js